var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeedlimit20After({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .speedlimit20_after_svg__cls-2{fill:#a9bf5c}.speedlimit20_after_svg__cls-39,.speedlimit20_after_svg__cls-4{fill:#343a50}.speedlimit20_after_svg__cls-57,.speedlimit20_after_svg__cls-61{fill:#898989}.speedlimit20_after_svg__cls-13,.speedlimit20_after_svg__cls-6,.speedlimit20_after_svg__cls-7,.speedlimit20_after_svg__cls-80{fill:#fff}.speedlimit20_after_svg__cls-10,.speedlimit20_after_svg__cls-19,.speedlimit20_after_svg__cls-20,.speedlimit20_after_svg__cls-21,.speedlimit20_after_svg__cls-27,.speedlimit20_after_svg__cls-29,.speedlimit20_after_svg__cls-34,.speedlimit20_after_svg__cls-39,.speedlimit20_after_svg__cls-42,.speedlimit20_after_svg__cls-43,.speedlimit20_after_svg__cls-45,.speedlimit20_after_svg__cls-46,.speedlimit20_after_svg__cls-50,.speedlimit20_after_svg__cls-51,.speedlimit20_after_svg__cls-54,.speedlimit20_after_svg__cls-55,.speedlimit20_after_svg__cls-6,.speedlimit20_after_svg__cls-76,.speedlimit20_after_svg__cls-77,.speedlimit20_after_svg__cls-79,.speedlimit20_after_svg__cls-8,.speedlimit20_after_svg__cls-80,.speedlimit20_after_svg__cls-83,.speedlimit20_after_svg__cls-84,.speedlimit20_after_svg__cls-85,.speedlimit20_after_svg__cls-9{stroke:#343a50}.speedlimit20_after_svg__cls-10,.speedlimit20_after_svg__cls-12,.speedlimit20_after_svg__cls-19,.speedlimit20_after_svg__cls-20,.speedlimit20_after_svg__cls-21,.speedlimit20_after_svg__cls-27,.speedlimit20_after_svg__cls-29,.speedlimit20_after_svg__cls-34,.speedlimit20_after_svg__cls-39,.speedlimit20_after_svg__cls-42,.speedlimit20_after_svg__cls-45,.speedlimit20_after_svg__cls-46,.speedlimit20_after_svg__cls-50,.speedlimit20_after_svg__cls-57,.speedlimit20_after_svg__cls-6,.speedlimit20_after_svg__cls-60,.speedlimit20_after_svg__cls-61,.speedlimit20_after_svg__cls-63,.speedlimit20_after_svg__cls-67,.speedlimit20_after_svg__cls-68,.speedlimit20_after_svg__cls-76,.speedlimit20_after_svg__cls-79,.speedlimit20_after_svg__cls-8,.speedlimit20_after_svg__cls-80,.speedlimit20_after_svg__cls-85,.speedlimit20_after_svg__cls-9{stroke-miterlimit:10}.speedlimit20_after_svg__cls-29,.speedlimit20_after_svg__cls-34,.speedlimit20_after_svg__cls-51,.speedlimit20_after_svg__cls-54,.speedlimit20_after_svg__cls-6{stroke-width:2px}.speedlimit20_after_svg__cls-7{opacity:.32}.speedlimit20_after_svg__cls-8{fill:#b01928}.speedlimit20_after_svg__cls-19,.speedlimit20_after_svg__cls-20,.speedlimit20_after_svg__cls-21,.speedlimit20_after_svg__cls-27,.speedlimit20_after_svg__cls-8{stroke-width:1.63px}.speedlimit20_after_svg__cls-9{fill:#936652}.speedlimit20_after_svg__cls-10,.speedlimit20_after_svg__cls-9{stroke-width:1.32px}.speedlimit20_after_svg__cls-10{fill:#ffccb8}.speedlimit20_after_svg__cls-14{fill:#343a51}.speedlimit20_after_svg__cls-12,.speedlimit20_after_svg__cls-16,.speedlimit20_after_svg__cls-51,.speedlimit20_after_svg__cls-55,.speedlimit20_after_svg__cls-68,.speedlimit20_after_svg__cls-84{fill:none}.speedlimit20_after_svg__cls-12,.speedlimit20_after_svg__cls-16{stroke:#343a51}.speedlimit20_after_svg__cls-12{stroke-width:.44px}.speedlimit20_after_svg__cls-15{fill:#ffb3ac}.speedlimit20_after_svg__cls-16,.speedlimit20_after_svg__cls-43,.speedlimit20_after_svg__cls-51,.speedlimit20_after_svg__cls-54,.speedlimit20_after_svg__cls-55,.speedlimit20_after_svg__cls-77,.speedlimit20_after_svg__cls-83,.speedlimit20_after_svg__cls-84{stroke-linecap:round;stroke-linejoin:round}.speedlimit20_after_svg__cls-16{stroke-width:.88px}.speedlimit20_after_svg__cls-18{fill:#ff8795}.speedlimit20_after_svg__cls-19{fill:#525254}.speedlimit20_after_svg__cls-20{fill:#404040}.speedlimit20_after_svg__cls-21{fill:#ba1e2c}.speedlimit20_after_svg__cls-26{fill:#969799}.speedlimit20_after_svg__cls-27{fill:#fcb042}.speedlimit20_after_svg__cls-29{fill:#3b3b3b}.speedlimit20_after_svg__cls-30{fill:#2cb4c3}.speedlimit20_after_svg__cls-34{fill:#8a2519}.speedlimit20_after_svg__cls-37,.speedlimit20_after_svg__cls-72{fill:#dedede}.speedlimit20_after_svg__cls-37,.speedlimit20_after_svg__cls-71{mix-blend-mode:multiply}.speedlimit20_after_svg__cls-39,.speedlimit20_after_svg__cls-43,.speedlimit20_after_svg__cls-46,.speedlimit20_after_svg__cls-50,.speedlimit20_after_svg__cls-55{stroke-width:3px}.speedlimit20_after_svg__cls-42,.speedlimit20_after_svg__cls-76,.speedlimit20_after_svg__cls-83{fill:#ffccb5}.speedlimit20_after_svg__cls-42,.speedlimit20_after_svg__cls-57{stroke-width:3px}.speedlimit20_after_svg__cls-43,.speedlimit20_after_svg__cls-77{fill:#5eb0d7}.speedlimit20_after_svg__cls-45,.speedlimit20_after_svg__cls-50,.speedlimit20_after_svg__cls-54{fill:#ffdccd}.speedlimit20_after_svg__cls-45{stroke-width:2.61px}.speedlimit20_after_svg__cls-46{fill:#b36375}.speedlimit20_after_svg__cls-79{fill:#46bea9}.speedlimit20_after_svg__cls-57,.speedlimit20_after_svg__cls-60,.speedlimit20_after_svg__cls-61,.speedlimit20_after_svg__cls-63,.speedlimit20_after_svg__cls-67,.speedlimit20_after_svg__cls-68{stroke:#2c3d4f}.speedlimit20_after_svg__cls-58,.speedlimit20_after_svg__cls-60{fill:#2c3d51}.speedlimit20_after_svg__cls-60,.speedlimit20_after_svg__cls-61,.speedlimit20_after_svg__cls-63,.speedlimit20_after_svg__cls-67{stroke-width:1.67px}.speedlimit20_after_svg__cls-63{fill:#2d3e50}.speedlimit20_after_svg__cls-67{fill:#2c3d4f}.speedlimit20_after_svg__cls-68{stroke-width:4.47px}.speedlimit20_after_svg__cls-76,.speedlimit20_after_svg__cls-77,.speedlimit20_after_svg__cls-79,.speedlimit20_after_svg__cls-80,.speedlimit20_after_svg__cls-83,.speedlimit20_after_svg__cls-85{stroke-width:2.61px}.speedlimit20_after_svg__cls-84{stroke-width:1.74px}.speedlimit20_after_svg__cls-85{fill:#f3af93}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Tempo_20_Nachher",
    "data-name": "Tempo 20_Nachher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.31 967.13 0 966.13 0 1079.99 0 1079.99 362.31 967.13",
    className: "speedlimit20_after_svg__cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "901.44 969 1258 967.13 1258 1080 1258 1080 901.44 969",
    className: "speedlimit20_after_svg__cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Himmel"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "-1 968.13 -.96 -1 1259 -1 1259 968.13 0 968.13 -1 968.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 0v967.13H0V0h1258m2-2H-2v971.13h1262V-2z",
    className: "speedlimit20_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-6.64 1080.99 357.49 968.76 902.29 969.34 1264.64 1081 -6.64 1080.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.64 969.76l544.5.58L1258 1080H0l357.64-110.24m-.3-2l-.29.09L-.59 1078.08l-12.69 3.92h1284.56l-12.69-3.91-355.86-109.67-.29-.08h-.3l-544.5-.58z",
    className: "speedlimit20_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "638.75 1002.57 626.63 1002.57 628.84 969.03 636.16 969.03 638.75 1002.57",
    className: "speedlimit20_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.56 1068.96 622.92 1068.96 625.35 1025.55 639.78 1025.55 641.56 1068.96",
    className: "speedlimit20_after_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26.42 182.87c8.55-20.09 30.17-34.43 55.69-34.43 25.22 0 46.68 14 55.43 33.68a45.84 45.84 0 0111.3-1.55c23 0 41.69 16.64 41.69 37.17S119 254.91 96 254.91H-12.42c-23 0-41.7-16.64-41.7-37.17 0-16.13 11.6-29.74 27.7-34.87zM1145 130.44c14.36-33.74 50.66-57.83 93.53-57.83 42.35 0 78.4 23.48 93.1 56.57a76.9 76.9 0 0118.95-2.61c38.69 0 70 28 70 62.44s-31.35 62.44-70 62.44H1168.5c-38.68 0-70-28-70-62.44-.03-27.1 19.5-49.93 46.5-58.57zM528.16 148.92c-9.29-21.84-32.8-37.43-60.55-37.43-27.42 0-50.75 15.2-60.28 36.62a49.77 49.77 0 00-12.27-1.69c-25 0-45.34 18.1-45.34 40.42s20.3 40.43 45.34 40.43H513c25 0 45.34-18.1 45.34-40.43-.05-17.54-12.66-32.32-30.18-37.92zM819.87 307.65c8.07-19 28.47-32.49 52.56-32.49 23.8 0 44.06 13.19 52.32 31.78a43.72 43.72 0 0110.65-1.46c21.74 0 39.35 15.71 39.35 35.08s-17.61 35.09-39.35 35.09H833.08c-21.74 0-39.36-15.71-39.36-35.09 0-15.22 10.95-28.05 26.15-32.91z",
    className: "speedlimit20_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.81 832.66l20.5-9.11-20.86-19.63c-.44.22-30.36-5.75-30.8-5.54a21.81 21.81 0 00-3 1.75l-74.18-1.75-7.62 2.75c-.58-.28-1.73 1.76-2.31 1.48s-.31 2.14-.74 1.92L386 826l23.3 11.42c11-6.56 20.23-13.27 35-12.23h36.39c14.43 2.81 34.73 4.22 47.12 7.47z",
    className: "speedlimit20_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.8 824h-43.36c-24.16 0-43.74 13.79-43.74 30.8l-21.93 3.83H557l-24.44-3.83C532.55 837.79 513 824 488.8 824zm38.79 30.14H406.75v-.59c0-15.06 17.35-27.28 38.75-27.28h43.34c21.4 0 38.75 12.22 38.75 27.28z",
    className: "speedlimit20_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.7 843.82c.08-.5-.35-.89-.9-1.58a29.66 29.66 0 01-1.68-2.7c-.81-1.37-.36-2.52 0-6.19.1-1.05.18-3.36.33-8 .1-2.93.15-4.39.12-4.84a19.4 19.4 0 00-4.05-9.9 22.63 22.63 0 00-9.34-7.2 24.46 24.46 0 00-11.25-1.58 22.87 22.87 0 00-7.65 1.47 21.15 21.15 0 00-10.58 9A21.87 21.87 0 00482 824a57.16 57.16 0 001.13 7.2c.72 3.33 1.33 4.81.78 7.08-.29 1.23-.74 3.11-2.25 3.94-.79.44-1.67.48-1.91 1.13a1.7 1.7 0 00.56 1.68 1.91 1.91 0 001.13.45c2.71.28 5.31 1.29 8 1.8 2.5.49 2 .56 4.38 1a60.43 60.43 0 007.09.9 52.42 52.42 0 0012.71-.34c3.63-.58 2.86-1 6.64-1.58a48.31 48.31 0 007.88-2.25c.43-.12 1.45-.5 1.56-1.19z",
    className: "speedlimit20_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.06 826.94a4.3 4.3 0 00-1.91 1.13 5.25 5.25 0 00-.11 6.41 4.65 4.65 0 002.13 1.46",
    className: "speedlimit20_after_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.28 810.85c-.67.47-5.36 3.58-6.85 7.2a15.41 15.41 0 00-1 4.28v1.8c0 2.11.09 4.32.34 7.31.11 1.33.17 2 .23 2.36a18 18 0 003.37 7.77A16 16 0 00499 847a15.36 15.36 0 008.21 1 16.21 16.21 0 009.23-5.06 20.7 20.7 0 004.5-8c2.94-9.09.45-17.86-.9-21.71",
    className: "speedlimit20_after_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.33 808.49a29.58 29.58 0 004.83 2 33.69 33.69 0 007 1.35c3.26.35 3.76.08 7.76.45 3.4.31 5.12.48 6.08 1.23 2.31 1.82 2.09 5.91 2 8 0 .49-.1 2.62-.22 5a8.6 8.6 0 00.11 2.93c.33 1.29.92 1.84 1.91 3.26 2.17 3.1 2.42 4.82 3 4.72.14 0 .73-.2 1-4.16a47.71 47.71 0 00-.33-9.11c-.77-7.2-1.2-8.86-2.48-10.58a11.45 11.45 0 00-2.25-2.25",
    className: "speedlimit20_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.58 850v1.5l-14.43-.75a2.62 2.62 0 00-1.59 0 3 3 0 00-1.91 2.47l5.4 1.35 8.63 2.4s14.1 1 14.32 1 15-4 15-4a4.52 4.52 0 00-.37-1.8 2 2 0 00-1-1.2 1.5 1.5 0 00-1 0l-15.53.23.08-1.72",
    className: "speedlimit20_after_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a51",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.32,
    d: "M485 852.54c1.5.32 3.71.78 6.42 1.29 6 1.12 9 1.69 12.2 1.8 3.64.13 6.25-.24 11.31-1 5.3-.75 8.61-.84 10-1.85a1.63 1.63 0 011.19-.4c.72.13 1.18 1 1.46 1.8l-.51 3.7-.22 6.09-4.48 15h-34.46l-4.26-16-.24-9.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.1 860.54a62.06 62.06 0 00-.82 8.4 60 60 0 00.52 9.83h4.58c-.14-.66-.26-1.34-.38-2a51.9 51.9 0 01-.52-12.45l-3.6.38M488.23 864.6l-4.13-1a41.91 41.91 0 01.23 5.55 42.39 42.39 0 01-1.35 9.52h4.65a52.54 52.54 0 00.75-12.07 51.7 51.7 0 00-.83-6.83M524.21 829.53c.19.41 0-.65 0 .26a19.13 19.13 0 01-.35 4.46",
    className: "speedlimit20_after_svg__cls-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 494.45,
    x2: 494.57,
    y1: 824.91,
    y2: 826,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 496.42,
    x2: 496.25,
    y1: 824.79,
    y2: 825.69,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 497.99,
    x2: 497.15,
    y1: 825.03,
    y2: 826,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 498.99,
    x2: 497.87,
    y1: 826,
    y2: 826.62,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.79,
    x2: 493.47,
    y1: 825.55,
    y2: 826.27,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.32 826.5c0-.29 1.11-.84 2.24-.88a5.2 5.2 0 012.54.87s.14.07.15.14c0 .24-.83.57-1.38.7a4 4 0 01-1.61.12 6.27 6.27 0 01-1.8-.81c-.06-.03-.13-.07-.14-.14z",
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.8,
    cy: 826.62,
    r: 0.78,
    className: "speedlimit20_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.95,
    x2: 514.83,
    y1: 824.91,
    y2: 825.99,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.98,
    x2: 513.16,
    y1: 824.78,
    y2: 825.68,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.41,
    x2: 512.25,
    y1: 825.02,
    y2: 825.99,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510.41,
    x2: 511.54,
    y1: 825.99,
    y2: 826.62,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 516.61,
    x2: 515.93,
    y1: 825.54,
    y2: 826.26,
    className: "speedlimit20_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.08 826.5c0-.29-1.11-.85-2.24-.89a5.2 5.2 0 00-2.54.87c-.05 0-.14.07-.14.15 0 .24.82.56 1.37.7a4.18 4.18 0 001.61.11 6.16 6.16 0 001.8-.8c.06-.03.13-.07.14-.14z",
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.6,
    cy: 826.62,
    r: 0.78,
    className: "speedlimit20_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.52,
    cy: 831.65,
    r: 2.39,
    className: "speedlimit20_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.6,
    cy: 831.65,
    r: 2.39,
    className: "speedlimit20_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.78 832a10.8 10.8 0 01-.11 1.43 3.13 3.13 0 000 1.39 1.35 1.35 0 00.26.56c.38.4 1.21.38 2.07 0M492.91 821.55a4.94 4.94 0 011.8-1 4 4 0 013.71.56M511.66 821.52a5.73 5.73 0 011.91-.53 6 6 0 012.92.45",
    className: "speedlimit20_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67984",
    d: "M501.83 837.78a14.25 14.25 0 012-.07c2.06.06 2.8.15 3.07.18 1.7.22 1.79.41 1.8.49.05.26-.55.56-1 .79a5.32 5.32 0 01-2.36.67 6.11 6.11 0 01-2.59-.6c-.42-.15-2.14-.79-2.06-1.16.01-.17.43-.22 1.14-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.33 839.2a5.85 5.85 0 001.69-.48l.79-.15a5.77 5.77 0 01-2.7 1.57 5.4 5.4 0 01-2.44.08 4.38 4.38 0 01-2.21-1.09 4 4 0 01-.79-1l.32.14.69.31.49.11a12.57 12.57 0 004.16.51z",
    className: "speedlimit20_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.26,
    height: 17.24,
    x: 513.14,
    y: 844.82,
    className: "speedlimit20_after_svg__cls-19",
    transform: "rotate(-29.97 514.886 853.548)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.24,
    height: 3.26,
    x: 520.45,
    y: 851.81,
    className: "speedlimit20_after_svg__cls-19",
    transform: "rotate(-60.02 529.086 853.455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.4 888.84a24.67 24.67 0 1124.67-24.67 24.7 24.7 0 01-24.67 24.67zm0-44.44a19.78 19.78 0 1019.77 19.77 19.8 19.8 0 00-19.77-19.77z",
    className: "speedlimit20_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.58,
    height: 33.51,
    x: 336.29,
    y: 970.57,
    className: "speedlimit20_after_svg__cls-20",
    rx: 6.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.58,
    height: 33.51,
    x: 555.04,
    y: 970.57,
    className: "speedlimit20_after_svg__cls-20",
    rx: 6.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.16 854.59c-1.88-3.37-4.67-5-7-6.3 0 0-7.72-4.31-22.78-1.48a4.09 4.09 0 00-2 .93c-2.16 2-1.11 6.29-.92 7 1.23 5.07 5.37 8.05 8.33 10.18a29.41 29.41 0 008.7 4.26 18.37 18.37 0 007.59 1.11c1.86-.18 6.55-.64 8.89-4.26 2.9-4.54-.28-10.5-.81-11.44zM561.62 856.18c1.88-3.36 4.67-5 7-6.29 0 0 7.71-4.32 22.77-1.48a4 4 0 012 .92c2.16 2 1.11 6.3.93 7-1.24 5.08-5.37 8-8.34 10.19a29.47 29.47 0 01-8.7 4.25 18.53 18.53 0 01-7.59 1.12c-1.85-.19-6.55-.65-8.89-4.26-2.89-4.55.29-10.5.82-11.45z",
    className: "speedlimit20_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.63,
    d: "M566.5 865.28c0-3.07-44-5.56-98.3-5.56s-98.3 2.49-98.3 5.56l-41.11 24.22 281.14 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.58 889.76c-10.31-7.32-69.37-12.93-140.7-12.93-75.32 0-137 6.26-142 14.17a14.86 14.86 0 00-6.57 12.34v37.92c2 7.36 67.91 13.27 149 13.27s147-5.91 149-13.27v-37.92a14.86 14.86 0 00-8.73-13.58z",
    className: "speedlimit20_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.13,
    x2: 467.12,
    y1: 797.57,
    y2: 811.6,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119.72,
    height: 47.23,
    x: 406.85,
    y: 918.47,
    fill: "#7d7e82",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.63,
    rx: 6.53
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9ad",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.63,
    d: "M619.92 941.68a6.52 6.52 0 00-2.51-5.13v4.71h0c-2 7.36-67.91 13.27-149 13.27s-147-5.91-149-13.27h0v-4.69a6.51 6.51 0 00-2.48 5.11v22.77a6.58 6.58 0 00.19 1.55 1.93 1.93 0 00-.19.83c0 9 67.84 16.23 151.52 16.23s151.53-7.26 151.53-16.23a1.94 1.94 0 00-.2-.83 6.1 6.1 0 00.2-1.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.61,
    height: 10.28,
    x: 447.81,
    y: 806.46,
    className: "speedlimit20_after_svg__cls-19",
    rx: 3.78
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.15 859.19 562.46 861.93 557.32 830.45 538.3 809.85 522.58 799.3 486.04 796.58 414.89 800.26 396.64 812.63 380.83 835.24 376.15 859.19",
    className: "speedlimit20_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.32 795.42h-64A64.58 64.58 0 00371.74 860v4.2h193.17V860a64.59 64.59 0 00-64.59-64.58zm57.27 63.21H379.2v-1.24a57.2 57.2 0 0157.21-57.2h64a57.2 57.2 0 0157.21 57.2z",
    className: "speedlimit20_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.63,
    y: 926,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.62,
    y: 930.21,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.64,
    y: 934.43,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.63,
    y: 938.64,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.64,
    y: 942.85,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 2.04,
    x: 409.63,
    y: 947.06,
    className: "speedlimit20_after_svg__cls-26",
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.29,
    height: 20.11,
    x: 323.8,
    y: 896.64,
    className: "speedlimit20_after_svg__cls-27",
    rx: 6.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.29,
    height: 20.11,
    x: 574.7,
    y: 896.38,
    className: "speedlimit20_after_svg__cls-27",
    rx: 6.53
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Haus_rechts"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "1259.38 967.1 1080.61 967.1 1080.61 735.51 1260.34 735.51 1259.38 967.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.66 591.84 1174.91 591.84 1080.51 735.67 1260.34 735.67 1260.66 591.84",
    className: "speedlimit20_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.28,
    height: 86.28,
    x: 1175.32,
    y: 768.72,
    className: "speedlimit20_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 763.62v96.49h96.5v-96.49zm5.11 5.1H1215v40.89h-39.71zm0 86.28v-40.89H1215V855zm86.28 0h-42.07v-40.89h42.07zm0-45.39h-42.07v-40.89h42.07z",
    className: "speedlimit20_after_svg__cls-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.28,
    height: 86.28,
    x: 1175.32,
    y: 862.13,
    className: "speedlimit20_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 857v96.49h96.5V857zm5.11 5.1H1215V903h-39.71zm0 86.28v-40.86H1215v40.89zm86.28 0h-42.07v-40.86h42.07zm0-45.39h-42.07v-40.86h42.07z",
    className: "speedlimit20_after_svg__cls-29"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 89.53,
    height: 153.6,
    x: 991.08,
    y: 813.39,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "991.08 813.39 1078.67 813.39 1080.61 757.96 1080.28 757.96 991.08 813.39",
    className: "speedlimit20_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Fenster-3",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.23,
    height: 54.23,
    x: 1008.73,
    y: 833,
    className: "speedlimit20_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.52 829.79v60.65h60.65v-60.65zm3.21 3.21h25v25.7h-25zm0 54.23v-25.7h25v25.7zm54.23 0h-26.44v-25.7H1063zm0-28.53h-26.44V833H1063z",
    className: "speedlimit20_after_svg__cls-29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Haus_links"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Fasade",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 299.95,
    x: -217.37,
    y: 669.23,
    fill: "#f2ab80",
    transform: "rotate(-180 13.495 819.205)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 84.34,
    x: -217.37,
    y: 884.84,
    fill: "#ca9072",
    transform: "rotate(-180 13.495 927.01)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "speedlimit20_after_svg__Tuer",
    d: "M-31.71 791.9h97.78v128.2A48.86 48.86 0 0117.21 969h-.06a48.86 48.86 0 01-48.86-48.9V791.9z",
    className: "speedlimit20_after_svg__cls-34",
    transform: "rotate(180 17.18 880.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.61,
    height: 20.25,
    x: -45.99,
    y: 948.93,
    fill: "#9a9a9a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 17.32 959.055)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Fenster-4",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.76,
    height: 77.06,
    x: 95.67,
    y: 733.84,
    fill: "#7fc3ca",
    transform: "rotate(-180 128.045 772.365)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Schatten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.21 768.13 130.45 768.13 130.45 733.84 130.45 733.84 131.21 739.25 131.21 768.13",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.94 768.13 95.67 768.13 95.67 733.84 95.67 733.84 97.94 741.05 97.94 768.13",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.67 733.84 97.94 741.05 125.64 741.05 125.64 733.73 95.67 733.84 95.67 733.84",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.94 810.9 95.67 810.9 95.67 776.61 95.67 776.61 97.94 781.92 97.94 810.9",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.67 776.61 97.94 781.92 125.64 781.92 125.64 776.53 95.67 776.61 95.67 776.61",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.2 810.9 130.45 810.9 130.45 776.61 130.45 776.61 131.2 780.52 131.2 810.9",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 776.61 131.2 780.52 160.43 780.4 160.43 776.53 130.45 776.61 130.45 776.61",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 733.84 131.21 739.25 160.43 739.25 160.43 733.73 130.45 733.84 130.45 733.84",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86 819.35l4.81 3.9 67-.11c.93 0 1.61-1.52 2-3l.46-4-74.25 3.21z",
    className: "speedlimit20_after_svg__cls-37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.21 733.84v-5.26a3.22 3.22 0 00-3.23-3.22H94.11a3.23 3.23 0 00-3.23 3.22V816.15a3.23 3.23 0 003.22 3.23H162a3.23 3.23 0 003.23-3.23v-5.25h.05v-77.06zm-4.78 34.29h-30v-34.29h30zm-34.79-34.29v34.29h-30v-34.29zm-30 42.77h30v34.29h-30zm34.78 34.29v-34.29h30v34.29z",
    className: "speedlimit20_after_svg__cls-34"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#555",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-230.53 673.41 16.23 480.8 258.82 673.41 -230.53 673.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.88,
    height: 110.24,
    x: 954.33,
    y: 865.2,
    className: "speedlimit20_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956.78,
    cy: 822.43,
    r: 37.98,
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e83434",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M956.78 866.52a44.1 44.1 0 1144.09-44.09 44.14 44.14 0 01-44.09 44.09zm0-75.95a31.86 31.86 0 1031.86 31.86 31.89 31.89 0 00-31.86-31.86z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343a50",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 47,
    transform: "matrix(1.04 0 0 1 932.07 836.89)"
  }, "\r\n      20\r\n     ")), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Frau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.94 905.52c-1 .2-2.57.53-4.42 1-5.13 1.34-6.43 2.25-7.49 1.53-1.27-.85-.77-3-.68-7.49.06-3.24-.41-6.47-.51-9.7-.31-9.22-2-17.76-2.56-23.49-.62-6.72-.28-16.63 4.6-29.62l8.17-12.41s7.32-.5 7.83 0c2.65 2.58 3.21 6.76 3.23 9.86.14 17.42.21 26.14-2.89 41.19-.45 2.17-1.7 8.05-3.58 17.36-.5 2.51-.91 4.57-1.19 6zM260.05 951.37a81.67 81.67 0 01-1.53-9.68 42.37 42.37 0 01.25-9.71c2.69-19.87 2.62-58.14-.51-84-.64-5.27-1.81-13.36-7.4-16.08-3.17-1.54-7.72-1.35-10.47 1s-2.62 5.78-1.53 21.7c.58 8.6 1.33 18.52 1.53 21.45.55 8.09.56 8.86 1 15.83 2 29.9 3.22 38.92 4.09 44.42.77 5 .41 14.69.9 17.19",
    className: "speedlimit20_after_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.21 922c3.23-8.15 3.78-10.18 7-18.33 2.89-.17 10.77.17 13.66 0L198 923",
    className: "speedlimit20_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.62 926.45A9.88 9.88 0 00198 923c-.49-6.11-7.06-12.38-14.07-12a13.59 13.59 0 00-8.58 4.12 16.5 16.5 0 00-4.81 11zM267.47 970.57c-3.23-8.15-3.78-10.17-7-18.32-2.89-.17-10.77.17-13.66 0l-6.08 19.37",
    className: "speedlimit20_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06 975.05a9.85 9.85 0 01-.34-3.43c.49-6.1 7.06-12.37 14.07-12a13.59 13.59 0 018.58 4.12 16.51 16.51 0 014.81 11z",
    className: "speedlimit20_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54525c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M259 793.86l-1.36 52.59a24.61 24.61 0 00-14.64 1.41 22.59 22.59 0 00-4.09 2.34c-1.35-11.71-2.89-20.73-4.08-26.9a16.73 16.73 0 00-2.39-6.46c-3.78-5.82-12.44-10.23-19.74-7.49-4.95 1.86-7.53 6.36-8.17 7.49-.84 1.46-1.53 3.84-2.89 8.52-.39 1.36-2.06 7.13-2.56 8.84-5-3.72-10.8-4.74-14.86-2.39a9.47 9.47 0 00-3.18 3.07c1.59-11.69 4.88-26.78 6.47-38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.07 769.64a24.49 24.49 0 01-1 7l-11.91 1.23q-5.1-23.54-10.9-47.66-2.17-9.07-4.42-18l14-1a25.54 25.54 0 012.35 3.58s.24.46.58 1.17c0 0 .62 1.33 1.12 2.75 1.39 3.94 6.13 29.27 6.13 29.27 1.37 7.34 2.06 11 2.38 12.26.85 3.24 1.68 5.76 1.67 9.4zM184.78 714.67c-5 18.92-9.41 35.55-15.69 55-.75 2.33-1.5 4.64-2.27 7l-3.17-4-10.24-1.48a324.85 324.85 0 017.51-31.91c2.55-8.8 6.28-17 9.13-24.51z",
    className: "speedlimit20_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.11 626.8 180.11 692.5 259.25 691.47 259.87 626.8 180.11 626.8",
    className: "speedlimit20_after_svg__cls-46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdccd",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.61,
    d: "M195.44 693.27a14.88 14.88 0 01-1.63-4h17.9V672h17.17v17.76h15.39a11.58 11.58 0 010 4.73c-1.18 5.41-6.25 8.32-9 9.92a23 23 0 01-8.73 3.1c-4.93.64-10-1.65-20.12-6.21-5.73-2.61-8.87-4.44-10.98-8.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 695c11.44 6.87 15 10.62 22.2 11a25.43 25.43 0 005-.29 32.76 32.76 0 0015.39-7.11c6.74-5.43 6.11-8.8 11.24-10.35a12.84 12.84 0 019.18.59 10.53 10.53 0 014.73 4.44 11.16 11.16 0 011.19 5c.08 1.71 2.65 1 1.9 4.29-.47 2.09 3.45 7.06 2.75 9.87l-15.45-.55v15.71l2.37 66.26-73.16 2.55L186 712.5l-16 2.68c0-.81.06-5 0-6.5-.27-6.91 1.81-9.08 2.32-13 .23-1.79.65-5.3 3.26-7.1 2.22-1.53 5-1.12 7.4-.59a57.17 57.17 0 0117.19 7.01z",
    className: "speedlimit20_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M187.59 692.1a47.35 47.35 0 00-1.77-5.2H208l-1.39 109.51h-19.07l-2.76-77a15.6 15.6 0 001.48-1.78c6.03-8.63 2.24-22.26 1.33-25.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6784b3",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M257 718a12.81 12.81 0 001.34 1.33l2.37 74.55-22.75.79-2.57-107.77h22.05c-.14.43-.5 1.5-.89 2.87-2.03 7.06-5.96 20.73.45 28.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46 650.63c-1.2-.17-5.29-.65-7.4-2.22-.75-.57-5.28-3.95-4.58-9 .48-3.53 5.87-6.52 9.67-7.55M254.83 632.87c.93 0 5.24-.82 7 .44 2.84 2.09 2.92 5.77 3 7.4s.12 5.71-3.11 8.29c-2.25 1.79-7.85 1.82-8.76 1.78",
    className: "speedlimit20_after_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.49 636.72a3.3 3.3 0 012.66.44c1.23.94 1.56 3.05.45 4.88M180.11 638.64a4.18 4.18 0 013.41.59c1.51 1.25 1.77 4.13 0 6.51",
    className: "speedlimit20_after_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.44 626.21a54.91 54.91 0 000 13.35c.49 4 1.43 11.92 6.22 19.37 1.5 2.34 11.32 17 28.41 17.22 12.3.16 20.65-7.27 22.64-9 10.6-9.44 11.63-22.28 12-26.69a44.24 44.24 0 00-.88-12.92c-.95-4.35-1.53-7-3.41-9.13-3.46-3.94-8.63-3.06-18.35-3.55-18.32-.93-19.2-5.05-28.7-2.67-2.73.69-11.64 2.92-15.69 10.36a16.79 16.79 0 00-.89 1.92z",
    className: "speedlimit20_after_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2 622.36a67.52 67.52 0 010 7.85 92.45 92.45 0 00-10.8-4.59c-4-1.4-7-2.18-10.06-3-7.68-1.95-11.51-2.93-16.28-3.26a62.26 62.26 0 00-16 1.19A91.46 91.46 0 00191.8 625a95.89 95.89 0 00-11.8 5.35 40 40 0 01-1-7.4c-.14-3-.68-14.69 6.95-24.41 2.73-3.47 5.43-5.33 8.88-7.7 4.31-3 11-7.44 20.87-8.58a40.31 40.31 0 0133.74 12.14 37 37 0 019.76 14.79 48.83 48.83 0 012 13.17z",
    className: "speedlimit20_after_svg__cls-46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.69,
    cy: 633.14,
    r: 5.14,
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.69,
    cy: 633.14,
    r: 2.7,
    className: "speedlimit20_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.01,
    cy: 633.44,
    r: 5.14,
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.01,
    cy: 633.44,
    r: 2.7,
    className: "speedlimit20_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M218.26 646.9a35.16 35.16 0 00-.44 4.22c-.08 1.73 0 2.35.44 2.89a3.65 3.65 0 001.89 1.11 3.59 3.59 0 001.33.11c.26 0 1.89-.23 2.11-1.22a2 2 0 00-1.45-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 0.87,
    d: "M220.29 655.64a1.47 1.47 0 00.45.92 1.48 1.48 0 002.44-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29 625.82a10.5 10.5 0 014.44-2.22 10.87 10.87 0 017.32 1M234.91 625.82a9.46 9.46 0 013.55-1.56 10.2 10.2 0 017.43 1.56",
    className: "speedlimit20_after_svg__cls-54"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.28,
    x2: 197.28,
    y1: 608.88,
    y2: 621.9,
    className: "speedlimit20_after_svg__cls-55"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.96,
    x2: 212.22,
    y1: 597.78,
    y2: 618.35,
    className: "speedlimit20_after_svg__cls-55"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.34,
    x2: 236.34,
    y1: 605.62,
    y2: 620.86,
    className: "speedlimit20_after_svg__cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23 663.9a10 10 0 001.68-.68 10.88 10.88 0 01-6.91 3.62 11.08 11.08 0 01-7.67-2.34 10.18 10.18 0 01-1.52-1.59l1.32.33a42.11 42.11 0 005.62 1.13 19 19 0 007.48-.47z",
    className: "speedlimit20_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e77c87",
    d: "M227.32 663.47c.38-.09.93-.22 1.59-.43a36.1 36.1 0 00-5.85-1.16 35.54 35.54 0 00-6.45-.13c-1.4.1-2.58.28-3.47.43.17.09.49.25.89.43 5.73 2.56 11.57 1.27 13.29.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36 977.38h-.06a3 3 0 01-2.94-3l.28-16.39-15.28-.68a3 3 0 11.26-6l18.21.8a3 3 0 012.86 3l-.33 19.31a3 3 0 01-3 2.96zM202.45 957.32h-.13l-18.2-.8a3 3 0 01-2.87-3l.34-19.31a3 3 0 013-2.95h.06a3 3 0 013 3l-.29 16.39 15.29.68a3 3 0 01-.14 6z",
    className: "speedlimit20_after_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.37,
    height: 5.89,
    x: 209.41,
    y: 951.37,
    className: "speedlimit20_after_svg__cls-58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.37,
    height: 5.89,
    x: 226.32,
    y: 951.37,
    className: "speedlimit20_after_svg__cls-58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.68,
    height: 165.59,
    x: 211.64,
    y: 870.71,
    fill: "#455064",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.45,
    height: 6.06,
    x: 175.02,
    y: 928.14,
    className: "speedlimit20_after_svg__cls-60",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.45,
    height: 6.06,
    x: 245.21,
    y: 977.24,
    className: "speedlimit20_after_svg__cls-60",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.18,
    height: 14.73,
    x: 205.04,
    y: 852.66,
    className: "speedlimit20_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.18,
    height: 14.73,
    x: 229.27,
    y: 852.66,
    className: "speedlimit20_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M229.77 864.44h-21.14a6.18 6.18 0 00-6.18 6.18v86.17a3.71 3.71 0 003.71 3.7h0a3.7 3.7 0 003.7-3.7v-86a24 24 0 0118.67-.55v86.56a3.71 3.71 0 007.41 0v-86.18a6.18 6.18 0 00-6.17-6.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.37,
    height: 27.27,
    x: 201.67,
    y: 941.02,
    className: "speedlimit20_after_svg__cls-60",
    rx: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.37,
    height: 27.27,
    x: 234.3,
    y: 941.02,
    className: "speedlimit20_after_svg__cls-60",
    rx: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94 849.62a2.94 2.94 0 00-2-.85 24.82 24.82 0 01-6.7-2.09c-.43-.18-2.25-.95-3.66-1.67v-3.7h-8.71V845c-1.41.72-3.23 1.49-3.66 1.67a24.82 24.82 0 01-6.7 2.09 2.94 2.94 0 00-2 .85 3 3 0 00-.33 2.57 3.32 3.32 0 001.47 1.95c.9.49 1.75.28 5-.43l3-.67a39.16 39.16 0 016.08-.95h3.01a39.16 39.16 0 016.08.95l3 .67c3.24.71 4.1.92 5 .43a3.32 3.32 0 001.47-1.95 3 3 0 00-.35-2.56z",
    className: "speedlimit20_after_svg__cls-63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    d: "M212.91 824.9h12.58v15.92a1.61 1.61 0 01-1.61 1.61h-9.35a1.61 1.61 0 01-1.61-1.61V824.9h-.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.63,
    height: 13.36,
    x: 208.33,
    y: 812,
    className: "speedlimit20_after_svg__cls-63",
    rx: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.67,
    height: 10.76,
    x: 209.31,
    y: 813.3,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    rx: 3.32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    d: "M219.1 788.3h0a4 4 0 014 4v20.43h0-8.08 0v-20.4a4 4 0 014-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.73 788.3h-21.52a3.31 3.31 0 010-6.61h21.52a3.31 3.31 0 010 6.61z",
    className: "speedlimit20_after_svg__cls-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75 784.83a67.51 67.51 0 0015.68.19c6.47-.69 10-2.06 12.73.19 2.44 2 1.92 4.94 5.41 7.22a12.06 12.06 0 004.56 1.61 28.56 28.56 0 0011.12.1",
    className: "speedlimit20_after_svg__cls-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.05 788.3h21.52a3.31 3.31 0 000-6.61h-21.52a3.31 3.31 0 000 6.61z",
    className: "speedlimit20_after_svg__cls-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 784.83a67.43 67.43 0 01-15.67.19c-6.47-.69-10-2.06-12.73.19-2.45 2-1.92 4.94-5.42 7.22a12.06 12.06 0 01-4.56 1.61 28.5 28.5 0 01-11.11.1",
    className: "speedlimit20_after_svg__cls-68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.22,
    cy: 780.9,
    r: 10.53,
    className: "speedlimit20_after_svg__cls-42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.13,
    cy: 781.69,
    r: 10.53,
    className: "speedlimit20_after_svg__cls-42",
    transform: "rotate(-22.5 282.13 781.706)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Baum"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1083.86,
    cy: 755.77,
    r: 77.79,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.87 757.26a77.78 77.78 0 0177.78-77.79c1.78 0 3.55.07 5.29.19a77.79 77.79 0 10-21.37 153.72 77.82 77.82 0 01-61.7-76.12z",
    className: "speedlimit20_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M1073.49 984.26a4.62 4.62 0 01-3.32-1.42 4.37 4.37 0 01-1.22-3.26l12.4-180.58-13.84-13.87a1.94 1.94 0 01-.43-2.13 2 2 0 012.67-1l12.35 6 1.78-25.92.11-2.14a4.39 4.39 0 018.76-.16l1.16 15.82 12.34-6.53h.24a2.44 2.44 0 01.53 0 2.94 2.94 0 012.76 2 2.9 2.9 0 01-1 3.26l-13.56 9.67 12.45 195.44a4.38 4.38 0 01-1.15 3.33 4.58 4.58 0 01-3.38 1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.38 757.26a2.78 2.78 0 012.87 2.63l1.33 18.09 14.17-7.5h.27a1.44 1.44 0 01.84 2.58l-14.19 10.24 12.5 196.26a3 3 0 01-3 3.22h-29.65a3 3 0 01-3-3.11l12.44-181.21-14.32-14.35a.46.46 0 01.32-.79.46.46 0 01.21.05l14.35 6.94 1.93-28.13.11-2.16a2.8 2.8 0 012.89-2.74m0-3a5.81 5.81 0 00-5.88 5.58l-.12 2.14-1.62 23.68-10.36-5a3.46 3.46 0 00-4 5.56l13.36 13.39-12.34 179.85a5.83 5.83 0 001.62 4.37 6.11 6.11 0 004.41 1.89h29.65a6.11 6.11 0 004.49-2 5.94 5.94 0 001.54-4.47l-12.4-194.57 12.85-9.28a4.37 4.37 0 001.52-4.93 4.42 4.42 0 00-4.18-3 4.15 4.15 0 00-.79.07l-.47.08-.42.22-10.1 5.35-1-13.51a5.8 5.8 0 00-5.87-5.41z",
    className: "speedlimit20_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "speedlimit20_after_svg__cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1092.69 779.47l15.57-8.24a1.39 1.39 0 00-1.51-.75l-14.17 7.5zM1086.29 791.67l2-29.51.11-2.16a2.75 2.75 0 011.43-2.37 2.9 2.9 0 00-4.36 2.37l-.11 2.16-1.92 28.13zM1073.38 979.65l12.44-181.21-13.51-13.54-3.21-1.55a.46.46 0 00-.53.74l14.32 14.35-12.44 181.21a3 3 0 003 3.11h2.93a3 3 0 01-3-3.11z",
    className: "speedlimit20_after_svg__cls-72"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Ball"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c6c8ca",
    d: "M1143.55 968.2a28.87 28.87 0 11-28.87 28.86 28.86 28.86 0 0128.87-28.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeef0",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1143.39 968.34a28.57 28.57 0 11-28.56 28.57 28.57 28.57 0 0128.56-28.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.39 968.34a28.5 28.5 0 0121.2 9.42 29.31 29.31 0 01-39 41.5 28.57 28.57 0 0117.78-50.92z",
    className: "speedlimit20_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M1143.59 972.7c-.82-.12-2.53-1.17-5.39-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.64 974.05l.13 9.84h-.67l-.13-9.85zM1134.92 972.37s-7.6 2.32-11.43 8.09l-.56-.37c4-6 11.8-8.37 11.82-8.37l.17.65zM1123.66 987.59s6.29.72 10.58 2.89l-.3.6c-4.17-2.11-10.31-2.82-10.32-2.82v-.67zM1118.92 995.47s-.4 8.45 3.54 13.89l-.54.39c-4.11-5.67-3.67-14.38-3.66-14.4l.66.12zM1135 1018.62a2.83 2.83 0 01.47.1c1.61.39 9.76 1.8 15.57-.51l.25.63c-6 2.39-14.32.94-16 .53l-.34-.08v-.67zM1168.49 995.18s0 9.45-4 14.33l-.52-.42c3.85-4.68 3.84-13.84 3.84-13.86l.67-.06zM1162.58 988.14a31.8 31.8 0 00-9.32 2.72l-.2-.6a31.7 31.7 0 019.34-2.72zM1137.94 1001.81l-7.58 10-.53-.41 7.58-10 .53.41zM1149.13 1001.24l7.32 9.73-.55.39-7.31-9.72.54-.4zM1152.65 972.06a20 20 0 0110.74 7.69l-.56.37a19.88 19.88 0 00-10.4-7.53l.21-.53zM1131.24 1020.26s1.25 1.72 2.94 3.69c-.43-.14-.85-.29-1.26-.46-1.31-1.58-2.2-2.8-2.21-2.81l.53-.42zM1156 1020.46a17.42 17.42 0 01-1.78 2.9c-.41.17-.83.32-1.25.47a16.73 16.73 0 002.42-3.66zM1116.66 993.46a19 19 0 00-1.79 1.93c0-.38.05-.76.08-1.13a18.12 18.12 0 011.36-1.41l.35.61zM1122.57 1014.57a10.17 10.17 0 01-1.8-.22c-.21-.27-.41-.55-.61-.83a10.49 10.49 0 002.42.38v.67zM1137.82 970.29l-1.82-1 1-.24 1.15.61-.29.61zM1148.74 969.83l1.45-.67 1 .26-2.22 1-.24-.63zM1120 982.16l-.2-1.29c.18-.27.36-.53.55-.79l.32 2-.67.06zM1165.89 981.73l.41-1.89.52.72-.26 1.22h-.67zM1170.4 992.79l1.39 1c0 .3.06.6.08.89l-1.86-1.35.39-.54zM1164 1013.59l3.06-.61c-.18.27-.37.54-.57.8l-2.34.46-.15-.65z",
    className: "speedlimit20_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.39 983.24l5 3.63 5 3.62-1.91 5.87-1.91 5.87h-12.34l-1.9-5.87-1.91-5.87 5-3.62 5-3.63zM1143.3 974.48a28.1 28.1 0 0110-1.9l-3.81-3.08a32.42 32.42 0 00-12.34 0l-3.81 3.08a22 22 0 0110 1.9zM1121.64 1008.48a14.88 14.88 0 008.81 2.47 18.7 18.7 0 005.81 8.09 10.28 10.28 0 01-5.12 2.2 18.87 18.87 0 01-9.16-6.92 14 14 0 01-.34-5.84zm34.1 2.13a20.86 20.86 0 009.07-2.35 10.34 10.34 0 01-.11 5.84s-2.48 4.41-9.27 7c0 0-3.46-.39-5.12-2.47 0 0 5.44-4.61 5.43-8.07zM1120 981.7a16.56 16.56 0 013.94-2.22s-1.44 3.43.24 8.54a15.62 15.62 0 00-5.36 8.18 6.79 6.79 0 01-2.6-2.84c-.17-4.29 2.46-10.13 3.78-11.66zm42.62-2.41a7.83 7.83 0 014.11 2.11 25.26 25.26 0 013.85 11.83l-2.46 3a21.07 21.07 0 00-5.9-8.36 24.45 24.45 0 00.4-8.58z",
    className: "speedlimit20_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Junge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1146.19 960.26c-.89.18-2.22.47-3.83.9-4.42 1.17-5.54 2-6.47 1.34-1.09-.75-.66-2.65-.58-6.55 0-2.83-.35-5.65-.45-8.48-.26-8.05-1.74-15.51-2.2-20.52-.54-5.88-.24-14.53 4-25.89l7.06-10.84s6.32-.43 6.76 0c2.29 2.25 2.77 5.91 2.79 8.61.12 15.23.18 22.85-2.5 36-.38 1.9-1.46 7-3.08 15.17-.44 2.19-.8 4-1 5.21zM1205.88 1000.34a71.83 71.83 0 01-1.32-8.47 36.62 36.62 0 01.22-8.48c2.32-17.36 2.26-50.81-.44-73.4-.56-4.61-1.57-11.68-6.4-14.06-2.74-1.34-6.67-1.17-9 .9s-2.26 5-1.33 19c.51 7.52 1.16 16.18 1.33 18.74.47 7.07.48 7.75.88 13.83 1.71 26.14 2.78 34 3.53 38.83.67 4.34.35 12.83.78 15",
    className: "speedlimit20_after_svg__cls-76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.14 974.64c2.79-7.12 3.27-8.89 6.06-16 2.5-.15 9.3.15 11.79 0l5.26 16.93",
    className: "speedlimit20_after_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 978.56a8.53 8.53 0 00.3-3c-.43-5.34-6.1-10.82-12.16-10.5a11.61 11.61 0 00-7.41 3.6 14.51 14.51 0 00-4.15 9.6zM1212.29 1017.11c-2.79-7.12-3.26-8.89-6.06-16-2.49-.15-9.29.15-11.79 0l-5.26 16.93",
    className: "speedlimit20_after_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.48 1021a8.53 8.53 0 01-.3-3c.43-5.34 6.1-10.81 12.16-10.5a11.61 11.61 0 017.41 3.6 14.51 14.51 0 014.15 9.6z",
    className: "speedlimit20_after_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54525c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.61,
    d: "M1205 862.69l-1.18 46a21 21 0 00-12.64 1.23 19.32 19.32 0 00-3.53 2c-1.17-10.23-2.5-18.11-3.53-23.5a14.85 14.85 0 00-2.06-5.65c-3.27-5.08-10.75-8.94-17-6.54-4.28 1.62-6.51 5.56-7.06 6.54-.73 1.28-1.33 3.36-2.5 7.45-.34 1.18-1.78 6.23-2.21 7.72-4.31-3.24-9.33-4.14-12.84-2.08a8.23 8.23 0 00-2.74 2.68c1.37-10.22 4.21-23.41 5.59-33.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.52 842.31a73.81 73.81 0 0112.94-37.31c1.68-.46 9.18-2.4 11.32.74 1.06 1.56.37 3.76 0 4.91-3.43 10.51-12 30.79-13 33.17M1203.09 813.46c.23 5 1.59 8.48 5 16.51 11.06 26.07 5.36 10.14 8.08 16.95 1 2.41 1.88 4.9 4.27 6a7.68 7.68 0 007.94-1.34c.56-.5 2.25-2 2.2-4 0-1.83-1.51-2.46-3.23-5.51a24.83 24.83 0 01-1.77-4.16c-2-5.62-5.61-18.07-7.5-24.39-1.51-5.05-2.12-6.79-4-7.89a8 8 0 00-9.55 1.49c-1.28 1.48-1.53 3.46-1.44 6.34z",
    className: "speedlimit20_after_svg__cls-79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194 797.54l4.28 9.22 2.76 6c13.57-1.32 16.11-5.75 16.76-7.58 1.12-3.15-1.28-4.41-3.68-14.08-2.22-8.92-1.21-12.56-4.85-16.06a18.22 18.22 0 00-6.62-3.79c-5-1.79-9.1-1.35-12.57-1.12-6.24.42-13.35.06-27.57-.67a77.27 77.27 0 00-12.79.23 32.65 32.65 0 00-5.65.79 25 25 0 00-2.51.77s-.58.22-1.14.47a20.86 20.86 0 00-9.45 8c-1.75 2.9-.89 3.35-3.15 9.83-2.68 7.65-4.5 8.78-4 11.15s3.44 5.56 15 7.59c2.15-6.55 4.78-13.67 6.18-13.39 1.59.33.85 10.11.44 16.07-.88 12.7-1.85 30.74-2.2 54 1 .45 2.43 1.1 4.28 1.79 21.08 7.77 42.27 1.15 51.29-1.79 1.75-.57 3.84-1.3 6.18-2.23l-5.59-39.57-5.4-25.63",
    className: "speedlimit20_after_svg__cls-80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.61,
    d: "M1133.41 726.22a86.81 86.81 0 01-1.56-15.6c0-7.58.05-12.15 2.42-17.4 4.24-9.38 13-14.3 18-15.84a45.16 45.16 0 017.6-1.56 51.36 51.36 0 016.73-.34c2.69 0 3.62.15 10.15.67 7.37.58 7.63.51 9 .89 3.17.87 5.21 2.18 8.27 4.13 4.68 3 8 5.09 10.47 9.15 1.37 2.2 2 4.37 3.31 8.7a41.66 41.66 0 012 8.92c.3 3.49-.7 4.59-.44 11 .23 5.77 1.73 19.82-.11 7.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.41 765.21a21.71 21.71 0 00.19 7.55 17.5 17.5 0 003.3 6.8 19.65 19.65 0 004.75 4.47 15.92 15.92 0 001.65-.9 15.86 15.86 0 006.51-17.62",
    className: "speedlimit20_after_svg__cls-76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.77 692a42.64 42.64 0 00-7.94 7.14 32.08 32.08 0 00-7.5 13.17 33.94 33.94 0 00-.88 5.35c-.45 4-.31 7.06 0 12.94a59.67 59.67 0 00.66 7.59 37.66 37.66 0 001.76 6.91 29.4 29.4 0 007.94 11.16 31.75 31.75 0 0013.9 8.25 27.29 27.29 0 0031.09-11.82 31.42 31.42 0 004.41-10.71c.83-4 .41-5.94.67-12.49.18-4.73.58-8.54.88-10.94",
    className: "speedlimit20_after_svg__cls-76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.61,
    d: "M1155.11 691c2.14 3.09 4.79 6.8 7.94 10.93 6.12 8 8.17 9.84 9.38 10.82a35.5 35.5 0 0011.9 6.36l-6.83-15.5 29.6 17.85-17.25-22.87 18.63 16c-.3-1-.76-2.44-1.38-4.13-1.56-4.25-3-8.13-5.45-11.6a27.25 27.25 0 00-9.15-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.68 725.68a8.28 8.28 0 00-5.73 2 8.75 8.75 0 00-2.54 4.8 9.07 9.07 0 00.33 6.36 8.25 8.25 0 003.86 3.68 9.33 9.33 0 006.18.67M1202 726.46a9 9 0 014.08 0 8.74 8.74 0 013 15.73 9.51 9.51 0 01-7.61 1.45",
    className: "speedlimit20_after_svg__cls-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.49 751.56a29.09 29.09 0 008.6 1.12 29.43 29.43 0 008.83-1.56M1166.91 741.52c.45.75 1.48 2.77 3.31 3.46a4.11 4.11 0 001.87.34c2.18-.2 4.15-3.49 4.31-3.8M1149.27 715.08a9.57 9.57 0 012.2-1.45 8.56 8.56 0 013.53-.89 8 8 0 014.74 1.56M1183.89 714a7.5 7.5 0 014-1.56 7.63 7.63 0 015.3 1.67",
    className: "speedlimit20_after_svg__cls-84"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1154.89,
    cy: 730.31,
    className: "speedlimit20_after_svg__cls-4",
    rx: 1.65,
    ry: 2.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1188.53,
    cy: 730.31,
    className: "speedlimit20_after_svg__cls-4",
    rx: 1.65,
    ry: 2.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.26 732.82a15.07 15.07 0 012.21-.33 13.2 13.2 0 012.09 0M1206.39 737.54a3.26 3.26 0 00-.11-5.58 3.27 3.27 0 00-4.19 1",
    className: "speedlimit20_after_svg__cls-84"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1166.57,
    cy: 788.26,
    className: "speedlimit20_after_svg__cls-4",
    rx: 1.41,
    ry: 1.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1178.04,
    cy: 788.26,
    className: "speedlimit20_after_svg__cls-4",
    rx: 1.41,
    ry: 1.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1172.65,
    x2: 1172.79,
    y1: 784.03,
    y2: 870.25,
    className: "speedlimit20_after_svg__cls-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.26 860.06a6.65 6.65 0 01.09-9.31 6.46 6.46 0 019.2.09l5.16 5.33a6.64 6.64 0 01-.09 9.3 6.46 6.46 0 01-9.2-.09z",
    className: "speedlimit20_after_svg__cls-85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.28 865.22a2.15 2.15 0 002.56-1.61l1.48-6.62a2.12 2.12 0 00-1.64-2.52 2.16 2.16 0 00-2.56 1.61l-1.47 6.62a2.11 2.11 0 001.63 2.52z",
    className: "speedlimit20_after_svg__cls-85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.55 850.84a6.46 6.46 0 00-9.2-.09 6.59 6.59 0 00-1.94 4.67 2.18 2.18 0 00-.29.66l-1.47 6.62a2.11 2.11 0 001.63 2.52 2.15 2.15 0 002.56-1.61l.54-2.41 4 4.18a6.46 6.46 0 009.2.09 6.64 6.64 0 00.09-9.3zM1112.8 842.37a6.45 6.45 0 019.19-.09 6.61 6.61 0 012 4.67 2.43 2.43 0 01.28.66l1.48 6.62a2.14 2.14 0 01-4.19.91l-.54-2.41-4 4.17a6.43 6.43 0 01-9.19.09 6.62 6.62 0 01-.09-9.3z",
    className: "speedlimit20_after_svg__cls-85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_after_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M-114.58 1031.36h-2c-11.3 0-20.5-5.79-20.5-12.9 0-5.95 6.39-11 15.4-12.49-2.59-2.21-4-4.89-4-7.67 0-5.88 6.16-10.92 15.08-12.44a8.34 8.34 0 01-.48-2.75c0-6.34 7.1-11.63 17-12.7.36-6.91 9.41-12.47 20.48-12.47a32.63 32.63 0 015.72.5c3.8-3.61 10.15-5.76 17.07-5.76a29.88 29.88 0 0111.16 2.07c3.52-3.21 9.24-5.26 15.46-5.53 3.79-3.69 10.19-5.89 17.2-5.89 11.15 0 20.25 5.63 20.49 12.61 7.18 1.07 13 4.54 15 9h.17c10 0 18.34 4.39 20.13 10.52 9.95.07 18.21 4.5 19.9 10.64 8.26 1.8 13.77 6.66 13.77 12.19 0 3.2-1.81 6.19-5.12 8.55 7.06 2.14 11.55 6.6 11.55 11.61 0 5.86-6.29 11-15.29 12.47l-187.16.42c-.36.01-.7.02-1.03.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 943.92c11 0 19.87 5.5 19.87 12.27a2.06 2.06 0 010 .26c7.5 1 13.42 4.54 15.22 9.11h.58c10 0 18.27 4.58 19.64 10.53h.23c10 0 18.29 4.59 19.64 10.55 7.93 1.61 13.66 6.22 13.66 11.65 0 3.45-2.31 6.56-6 8.78 7.29 1.82 12.44 6.23 12.44 11.38 0 5.68-6.27 10.45-14.76 11.84l-187.11.43h-3c-11 0-19.87-5.5-19.87-12.27 0-6 7.06-11 16.36-12.07-3.08-2.16-5-5-5-8.09 0-5.81 6.55-10.67 15.33-11.94a8 8 0 01-.73-3.25c0-6.16 7.37-11.25 17-12.12v-.15c0-6.78 8.89-12.27 19.86-12.27a30.5 30.5 0 015.92.56c3.51-3.49 9.74-5.82 16.87-5.82a28.85 28.85 0 0111.3 2.19c3.33-3.23 9-5.42 15.59-5.66 3.49-3.52 9.76-5.88 16.93-5.88m0-1.26c-7.06 0-13.54 2.2-17.47 5.9-6.09.31-11.72 2.31-15.31 5.42a30.72 30.72 0 00-11-2c-6.94 0-13.33 2.12-17.27 5.72a32.38 32.38 0 00-5.52-.46c-11.13 0-20.27 5.54-21.07 12.54-9.92 1.23-17 6.7-17 13.26a8.83 8.83 0 00.3 2.26c-8.85 1.71-14.91 6.9-14.91 12.93a10.33 10.33 0 003.28 7.27c-8.65 1.76-14.67 6.91-14.67 12.89 0 7.46 9.48 13.53 21.13 13.53h3l187.05-.42h.2c9.32-1.53 15.82-6.91 15.82-13.09 0-5-4.17-9.49-10.84-11.84 2.87-2.35 4.41-5.24 4.41-8.32 0-5.75-5.55-10.8-13.9-12.72-2-6.12-10.1-10.53-19.94-10.74-2.12-6.11-10.43-10.46-20.36-10.52-2.2-4.38-7.82-7.78-14.78-8.92-.67-7.08-9.88-12.7-21.09-12.7z",
    className: "speedlimit20_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "speedlimit20_after_svg__cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-127.56 1024.12c0-6 7.06-11 16.35-12.07-3.07-2.16-5-5-5-8.09 0-5.81 6.55-10.67 15.33-11.94a8 8 0 01-.73-3.25c0-6.17 7.37-11.25 17-12.13v-.14c0-6.78 8.89-12.27 19.86-12.27a31.39 31.39 0 015.92.55c3.5-3.48 9.74-5.78 16.83-5.78a29 29 0 0111.3 2.18c3.33-3.22 9-5.42 15.58-5.65 3.5-3.52 9.76-5.88 16.94-5.88A30 30 0 0111 951c-3.17-4.18-10-7.08-18-7.08-7.17 0-13.44 2.36-16.93 5.88-6.56.24-12.26 2.43-15.59 5.66a28.85 28.85 0 00-11.3-2.19c-7.13 0-13.36 2.33-16.87 5.81a31.39 31.39 0 00-5.92-.55c-11 0-19.86 5.49-19.86 12.27v.15c-9.59.87-17 6-17 12.12a7.93 7.93 0 00.72 3.25c-8.78 1.27-15.33 6.13-15.33 11.94 0 3.1 1.88 5.93 5 8.09-9.3 1-16.36 6-16.36 12.07 0 4.74 4.37 8.85 10.74 10.89a8.56 8.56 0 01-1.86-5.19z",
    className: "speedlimit20_after_svg__cls-72"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedlimit20After);
export default __webpack_public_path__ + "static/media/speedlimit20.after.e217fbe8.svg";
export { ForwardRef as ReactComponent };